module.exports = __webpack_public_path__ + "static/media/announce.79f7108b.png";